import { Checkbox as ReactCheckbox } from '@a-ui/react';
import { Field, FieldProps } from 'formik';
import React from 'react';

type CheckOption = {
  label: string;
  value: string;
  disabled?: boolean;
};

interface CheckGroupFieldProps {
  option: CheckOption;
  htmlId: string;
  name: string;
}

const CheckGroupField: React.FC<CheckGroupFieldProps> = ({ name, option, htmlId }) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps<string[]>) => {
        const checked = Array.isArray(field.value) && field.value.includes(option.value);

        const toggleCheckbox = () => {
          const currentValues = field.value || [];

          if (checked) {
            form.setFieldValue(
              name,
              currentValues.filter((v) => v !== option.value),
            );
          } else {
            form.setFieldValue(name, [...currentValues, option.value]);
          }
        };

        return (
          <ReactCheckbox
            id={htmlId}
            name={name}
            label={option.label}
            onChange={toggleCheckbox}
            checked={checked}
          />
        );
      }}
    </Field>
  );
};

export default CheckGroupField;
